import { __assign, __rest } from "tslib";
import React from 'react';
import { Tab as MaterialTab, makeStyles, createStyles, } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            color: theme.palette.grey[800],
            fontWeight: 'normal',
            textTransform: 'inherit',
            fontSize: theme.typography.fontSize,
            minWidth: 'auto',
            lineHeight: theme.typography.body1.lineHeight,
            padding: theme.spacing(0.5) + "px " + theme.spacing(2.8) + "px",
            letterSpacing: '0.2px',
        },
        selected: {
            color: theme.palette.common.black,
            fontWeight: 'bold',
            letterSpacing: 0,
        },
    });
});
export var Tab = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(MaterialTab, __assign({ classes: classes }, props), children));
};
//# sourceMappingURL=Tab.js.map